import React, { memo } from 'react';
import QRCode from 'qrcode.react';

import mutedIcon from "images/scrawl_muted.png";
import unmutedIcon from "images/scrawl_unmuted.png";
import fullscreenIcon from "images/scrawl_fullscreen.png";
import helpIcon from "images/scrawl_help.png";

import styles from './RoomDetails.module.scss';

const fullscreenAvailable =
    typeof document !== "undefined" &&
        (document.fullscreenEnabled || document.mozFullscreenEnabled || document.webkitFullscreenEnabled || document.msFullscreenEnabled) ? true : false;

const RoomDetails = memo(function RoomDetails({ url, displayUrl, muted, roomId, isMirror, hideButtons, onToggleMute, onToggleFullScreen, onToggleMenu }) {
    return (
        <div className={styles.roomCode}>
            <div className={styles.text}>{displayUrl || window.location.hostname}</div>
            <div className={styles.topRow}>
                <div className={styles.qrCodeBox}>
                    <QRCode
                        className={styles.qrCode}
                        value={`${url}/play/?qrCode=${roomId}`}
                        bgColor="rgba(0,0,0,0)"
                    />
                </div>
                {
                    !hideButtons &&
                    <div className={styles.iconsBox}>
                        <div className={styles.iconButton} onClick={() => onToggleMute()}>
                            <img src={muted ? mutedIcon : unmutedIcon} className={styles.icon} alt="mute" />
                        </div>
                        {fullscreenAvailable && (
                            <div className={styles.iconButton} onClick={() => onToggleFullScreen()}>
                                <img src={fullscreenIcon} className={styles.icon} alt="fullscreen" />
                            </div>
                        )}
                        {!isMirror && (
                            <div className={styles.iconButton} onClick={() => onToggleMenu()}>
                                <img src={helpIcon} className={styles.icon} alt="help" />
                            </div>
                        )}
                    </div>
                }
            </div>
            <div className={styles.codeRow}>
                <span className={styles.codeLabel}>CODE</span>
                <span className={styles.codeValue}>{roomId}</span>
            </div>
            {isMirror && <div className={styles.mirrorBadge}>CONNECT</div>}
        </div>
    );
});

export default RoomDetails;
